module.exports = __webpack_public_path__ + "media/images/webshop-nl_logo_beta_01-333ac082a80015602958fca8fddc723d.svg";